import { ModelCollection } from '@/modules/core/app/models/ModelCollection';
import { OpportunityItem } from '@/modules/opportunity/models/OpportunityItem';

export class OpportunityItemCollection extends ModelCollection<OpportunityItem> {
  constructor(items: OpportunityItem[] | OpportunityItemCollection | null = null) {
    super(items, OpportunityItem);
  }

  static mapModel(
    items: OpportunityItem[] | OpportunityItemCollection | null = null
  ): OpportunityItemCollection {
    return new this(items);
  }
}
